<template>
  <div>
    <social-sharing-new
      :facebook="facebook"
      :show-facebook="showFacebook"
      :googleplus="googleplus"
      :show-googleplus="showGoogleplus"
      :line="line"
      :show-line="showLine"
      :linkedin="linkedin"
      :show-linkedin="showLinkedin"
      :odnoklassniki="odnoklassniki"
      :show-odnoklassniki="showOdnoklassniki"
      :pinterest="pinterest"
      :show-pinterest="showPinterest"
      :reddit="reddit"
      :show-reddit="showReddit"
      :skype="skype"
      :show-skype="showSkype"
      :telegram="telegram"
      :show-telegram="showTelegram"
      :twitter="twitter"
      :show-twitter="showTwitter"
      :wechat="wechat"
      :show-wechat="showWechat"
      :vk="vk"
      :show-vk="showVk"
      :weibo="weibo"
      :show-weibo="showWeibo"
      :whatsapp="whatsapp"
      :show-whatsapp="showWhatsapp"
      :kakao="kakao"
      :show-kakao="showKakao"
      :naver="naver"
      :show-naver="showNaver"
      :tumblr="tumblr"
      :show-tumblr="showTumblr"
      :show-mediatext="showMediatext"
      :quote="quote"
      :hashtags="hashtags"
      :twitter-user="twitterUser"
      :facebook-tags="facebookTags"
      :twitter-tags="twitterTags"
      :skype-tags="skypeTags"
      :pinterest-tags="pinterestTags"
      :tumbler-tags="tumblerTags"
      :naver-tags="naverTags"
      :line-tags="lineTags"
      :weibo-tags="weiboTags"
      :whats-app-tags="whatsAppTags"
      :telegram-tags="telegramTags"
      :linkedin-tags="linkedinTags"
      :reddit-tags="redditTags"
      :google-plus-tags="googlePlusTags"
      :kakao-tags="kakaoTags"
      :vkontakte-tags="vkontakteTags"
      :odnoklassniki-tags="odnoklassnikiTags"
      :we-chat-tags="weChatTags"
      :is-right-to-left-actives="isRightToLeftActive"
    ></social-sharing-new>
  </div>
</template>

<script>
import SocialSharingNew from './SocialSharingNew.vue';

export default {
  name: 'social-sharing',
  components: {
    SocialSharingNew,
  },
  props: {
    /**
     * Facebook quote
     * @var string
     */
    quote: {
      type: String,
      default: '',
    },

    /**
     * Twitter hashtags
     * @var string
     */
    hashtags: {
      type: String,
      default: '',
    },

    /**
     * Twitter user.
     * @var string
     */
    twitterUser: {
      type: String,
      default: '',
    },

    /**
     * Flag that indicates if counts should be retrieved.
     * - NOT WORKING IN CURRENT VERSION
     * @var mixed
     */
    withCounts: {
      type: [String, Boolean],
      default: false,
    },

    /**
     * Google plus key.
     * @var string
     */
    googleKey: {
      type: String,
      default: undefined,
    },

    /**
     * Network sub component tag.
     * Default to span tag
     */
    networkTag: {
      type: String,
      default: 'span',
    },
    /**
     * facebook media status.
     * @var boolean
     */
    showFacebook: {
      type: Boolean,
      default: false,
    },
    /**
     * googleplus media status.
     * @var boolean
     */
    showGoogleplus: {
      type: Boolean,
      default: false,
    },
    /**
     * Line media status.
     * @var boolean
     */
    showLine: {
      type: Boolean,
      default: false,
    },
    /**
     * Linkedin media status.
     * @var boolean
     */
    showLinkedin: {
      type: Boolean,
      default: false,
    },
    /**
     * Odnoklassniki media status.
     * @var boolean
     */
    showOdnoklassniki: {
      type: Boolean,
      default: false,
    },
    /**
     * Pinterest media status.
     * @var boolean
     */
    showPinterest: {
      type: Boolean,
      default: false,
    },
    /**
     * Reddit media status.
     * @var boolean
     */
    showReddit: {
      type: Boolean,
      default: false,
    },
    /**
     * Skype media status.
     * @var boolean
     */
    showSkype: {
      type: Boolean,
      default: false,
    },
    /**
     * Telegram media status.
     * @var boolean
     */
    showTelegram: {
      type: Boolean,
      default: false,
    },
    /**
     * Twitter media status.
     * @var boolean
     */
    showTwitter: {
      type: Boolean,
      default: false,
    },
    /**
     * VK media status.
     * @var boolean
     */
    showVk: {
      type: Boolean,
      default: false,
    },
    /**
     * Weibo media status.
     * @var boolean
     */
    showWeibo: {
      type: Boolean,
      default: false,
    },
    /**
     * Whatsapp media status.
     * @var boolean
     */
    showWhatsapp: {
      type: Boolean,
      default: false,
    },
    /**
     * Naver media status.
     * @var boolean
     */
    showNaver: {
      type: Boolean,
      default: false,
    },
    /**
     * Tumblr media status.
     * @var boolean
     */
    showTumblr: {
      type: Boolean,
      default: false,
    },
    /**
     * Kakao media status.
     * @var boolean
     */
    showKakao: {
      type: Boolean,
      default: false,
    },
    /**
     * Wechat media status.
     * @var boolean
     */
    showWechat: {
      type: Boolean,
      default: false,
    },
    /**
     * Text for facebook.
     * @var string
     */
    facebook: {
      type: String,
      default: 'Facebook',
    },
    /**
     * Text for googleplus.
     * @var string
     */
    googleplus: {
      type: String,
      default: 'Googleplus',
    },
    /**
     * Text for line.
     * @var string
     */
    line: {
      type: String,
      default: 'Line',
    },
    /**
     * Text for linkedin.
     * @var string
     */
    linkedin: {
      type: String,
      default: 'Linkedin',
    },
    /**
     * Text for odnoklassniki.
     * @var string
     */
    odnoklassniki: {
      type: String,
      default: 'Odnoklassniki',
    },
    /**
     * Text for pinterest.
     * @var string
     */
    pinterest: {
      type: String,
      default: 'Pinterest',
    },
    /**
     * Text for reddit.
     * @var string
     */
    reddit: {
      type: String,
      default: 'Reddit',
    },
    /**
     * Text for skype.
     * @var string
     */
    skype: {
      type: String,
      default: 'Skype',
    },
    /**
     * Text for telegram.
     * @var string
     */
    telegram: {
      type: String,
      default: 'Telegram',
    },
    /**
     * Text for twitter.
     * @var string
     */
    twitter: {
      type: String,
      default: 'Twitter',
    },
    /**
     * Text for vk.
     * @var string
     */
    vk: {
      type: String,
      default: 'VKontakte',
    },
    /**
     * Text for weibo.
     * @var string
     */
    weibo: {
      type: String,
      default: 'Weibo',
    },
    /**
     * Text for whatsapp.
     * @var string
     */
    whatsapp: {
      type: String,
      default: 'Whatsapp',
    },
    /**
     * Text for kakao.
     * @var string
     */
    kakao: {
      type: String,
      default: 'Kakao',
    },
    wechat: {
      type: String,
      default: 'WeChat',
    },
    /**
     * Text for naver.
     * @var string
     */
    naver: {
      type: String,
      default: 'Naver',
    },
    /**
     * Text for tumblr.
     * @var string
     */
    tumblr: {
      type: String,
      default: 'Tumblr',
    },
    /**
     * Status for showMediatext.
     * @var boolean
     */
    showMediatext: {
      type: Boolean,
      default: true,
    },
    /**
     * facebook tag Attributes.
     * @var tagging
     */
    facebookTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    twitterTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    naverTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    lineTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    weiboTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    whatsAppTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    telegramTags: {
      type: String,
      default: '',
    },
    /**
     * twitter tag Attributes.
     * @var tagging
     */
    tumblerTags: {
      type: String,
      default: '',
    },
    /**
     * pinterestTags.
     * @var tagging
     */
    pinterestTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    skypeTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    googlePlusTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    redditTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    linkedinTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    odnoklassnikiTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    vkontakteTags: {
      type: String,
      default: '',
    },
    /**
     * skypeTags .
     * @var tagging
     */
    kakaoTags: {
      type: String,
      default: '',
    },
    /**
     * Wechat tags .
     * @var tagging
     */
    weChatTags: {
      type: String,
      default: '',
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
